import Add from '@material-ui/icons/Add'
import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Modal from '../../components/UI/Modal/Modal'
import Search from '../../components/UI/Search/Search'
import Select from '../../components/UI/Select/Select'
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import UnitPickupAddressForm from '../../components/UnitPickupAddress/UnitPickupAddressForm'
import FetchData from '../../shared/fetchData'
import { checkValidity, updateObject } from '../../shared/utility'
import './UnitPickupAddresses.css'

const UnitPickupAddresses = () => {

    const [unitPickupAddresses, setUnitPickupAddresses] = useState([]);
    const [searchParams, setSearchParams] = useState({
        tinextId: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شناسه تینکس'
            },
            validation: {
                // required: true
            },
            errorMessage: 'فیلد الزامی است',
            valid: true,
            value: ''
        },
        lat: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'طول جغرافیایی'
            },
            validation: {
                // required: true
            },
            errorMessage: 'فیلد الزامی است',
            valid: true,
            value: ''
        },
        lon: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'عرض جغرافیایی'
            },
            validation: {
                // required: true
            },
            errorMessage: 'فیلد الزامی است',
            valid: true,
            value: ''
        }
    })
    const [unitPickupAddressId, setUnitPickupAddressId] = useState('');
    const [rerender, setRerender] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [pageCount, setPageCount] = useState(0)
    const [tableData, setTableData] = useState([])
    const [edit, setEdit] = useState(false);
    const [unitPickupAddress, setUnitPickupAddress] = useState('');
    const [loading, setLoading] = useState(false)
    const [newUnitPickupAddressPage, setNewUnitPickupAddressPage] = useState(false);
    const [view, setView] = useState(false);
    const [units, setUnits] = useState([]);
    const [cities, setCities] = useState([]);
    const [unit, setUnit] = useState('');
    const [city, setCity] = useState('');
    const [modalContent, setModalContent] = useState('')
    const [permission] = useState(window.localStorage.getItem("permission"));
    const ref = useRef();
    useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        var info = {
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setUnits(result.units)
            })
            .catch(error => console.log(error))
        var info = {
            "geoName": {
                "type": "CTY"
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/geonames/getGeoNames'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setCities(result.geoNames);
            })
            .catch(error => console.log(error))
    }, [])


    const unitPickupAddressChangeState = (id) => {
        setUnitPickupAddressId(id)
        setModalContent(<div>
            <div className='row justify-content-center'>
                آیا از تغییر وضعیت مطمئن هستید؟
            </div>
            <div className='row justify-content-center mt-3'>
                <div className='col-6'>
                    <Button btnType='Success' clicked={() => ref.current.closeModal()} >خیر</Button>
                </div>
                <div className='col-6'>
                    <Button btnType='Success' clicked={() => unitPickupAddressChangeStateSubmit(id)} >بله</Button>
                </div>
            </div>
        </div>)
        ref.current.openModal()
    }

    const finalizeUnitPickupAddress = (id, data) => {
        const row = data.filter(d => d.id === id);
        if (!!row && row.length > 0) {
            if (row[0].finalized === '1') {
                toast.error('رکورد مورد نظر نهایی است')
            } else {
                setUnitPickupAddressId(id)
                setModalContent(<div>
                    <div className='row justify-content-center'>
                        آیا از نهایی کردن مطمئن هستید؟
                    </div>
                    <div className='row justify-content-center mt-3'>
                        <div className='col-6'>
                            <Button btnType='Success' clicked={() => ref.current.closeModal()} >خیر</Button>
                        </div>
                        <div className='col-6'>
                            <Button btnType='Success' clicked={() => finalizeUnitPickupAddressSubmit(id)} >بله</Button>
                        </div>
                    </div>
                </div>)
                ref.current.openModal()
            }
        }
    }
    const unitPickupAddressChangeStateSubmit = (id) => {
        var info = {
            "unitPickupAddress": {
                "id": id
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/unitPickupAddresses/changeUnitPickupAddressState'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0') {
                    ref.current.closeModal()
                }
                search()
            })
            .catch(error => console.log(error))
    }
    const finalizeUnitPickupAddressSubmit = (id) => {
        var info = {
            "unitPickupAddress": {
                "id": id
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/unitPickupAddresses/finalizeUnitPickupAddress'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0') {
                    ref.current.closeModal()
                }
                search()
            })
            .catch(error => console.log(error))
    }

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "unitPickupAddress": {
                "tinextId": searchParams.tinextId.value !== '' ? searchParams.tinextId.value : null,
                "lat": searchParams.lat.value !== '' ? searchParams.lat.value : null,
                "lon": searchParams.lon.value !== '' ? searchParams.lon.value : null,
                "city": city !== '' && !!city ? { id: city.value } : null,
                "unit": unit !== '' && !!unit ? { id: unit.value } : null,
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/unitPickupAddresses/getUnitPickupAddresses'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.unitPickupAddresses)
                    pushData(newList)
                    setUnitPickupAddresses(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'tinextId',
                header: "شناسه تینکست",
                align: 'center',
            },
            {
                accessorKey: 'unit',
                header: "سازمان",
                align: 'center',
            },
            {
                accessorKey: 'addressTitle',
                header: "نام آدرس",
                align: 'center',
            },
            {
                accessorKey: 'city',
                header: "شهر",
                align: 'center',
            },
            {
                accessorKey: 'addressText',
                header: "آدرس",
                align: 'center',
            },
            {
                accessorKey: 'plateNumber',
                header: "پلاک",
                align: 'center',
            },
            {
                accessorKey: 'unitNumber',
                header: "واحد",
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: "فعال است؟",
                align: 'center',
            },
            {
                accessorKey: 'finalized',
                header: "نهایی است؟",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                tinextId: d.tinextId,
                unit: !!d.unit ? d.unit.unitName : '',
                addressTitle: d.addressTitle,
                city: !!d.city ? d.city.description : '',
                addressText: d.addressText,
                plateNumber: d.plateNumber,
                unitNumber: d.unitNumber,
                isActive: !!d.isActive && d.isActive === '1' ? 'فعال است' : 'فعال نیست',
                finalized: !!d.finalized && d.finalized === '1' ? 'نهایی شده' : 'نهایی نشده',
                subRows: [
                    { header: 'نام نماینده', value: d.agentName },
                    { header: 'نام خانوادگی نماینده', value: d.agentLastName },
                    { header: 'تلفن همراه نماینده', value: d.agentCellNumber },
                ],
            });
        })
        buttons.push({ id: 1, text: 'ویرایش', clicked: editUnitPickupAddress });
        buttons.push({ id: 2, text: 'مشاهده', clicked: viewUnitPickupAddress });
        buttons.push({ id: 6, text: 'تغییر وضعیت', clicked: unitPickupAddressChangeState });
        buttons.push({ id: 6, text: 'نهایی سازی', clicked: finalizeUnitPickupAddress });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const inputChangedHandlerSearch = (event, controlName) => {
        if (controlName == 'cellNumber' && event.target.value.length > 11) {
        } else {
            const updatedControls = updateObject(searchParams, {
                [controlName]: updateObject(searchParams[controlName], {
                    value: event.target.value,
                    valid: checkValidity(event.target.value, searchParams[controlName].validation)
                })
            });
            setSearchParams(updatedControls);
        }
    }
    const afterCloseModal = (event) => {

    }
    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }
    const toggleNewUnitPickupAddressForm = (event, value) => {
        if (value == false) {
            search();
        }
        setNewUnitPickupAddressPage(value)
        setView(false)
    }

    const addNewUnitPickupAddressType = (event, id) => {
        setUnitPickupAddress('')
        setEdit(false)
        setNewUnitPickupAddressPage(true)
    }

    const editUnitPickupAddress = (id, data) => {
        const unt = data.filter(u => u.id == id)
        if (unt != null && unt.length != 0) {
            if (unt[0].finalized === '1') {
                toast.error('رکورد مورد نظر نهایی است')
            } else {
                setUnitPickupAddress(unt[0])
                setEdit(true)
                setNewUnitPickupAddressPage(true)
            }
        }
    }

    const viewUnitPickupAddress = (id, data) => {
        const unt = data.filter(u => u.id == id)
        if (unt != null && unt.length != 0) {
            setUnitPickupAddress(unt[0])
            setEdit(true)
            setNewUnitPickupAddressPage(true)
            setView(true);
        }
    }


    const changeUnit = (selectedOption) => {
        setUnit(selectedOption)
    }
    const changeCity = (selectedOption) => {
        setCity(selectedOption)
    }

    let unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName,
            })
        })
    }

    let cityList = []
    if (cities != null && cities.length != 0) {
        cities.map(z => {
            cityList.push({
                value: z.id,
                label: z.description,
            })
        })
    }

    const formElementsArrayS = [];
    for (let key in searchParams) {
        formElementsArrayS.push({
            id: key,
            config: searchParams[key]
        });
    }
    let formS = formElementsArrayS.map(formElement => {
        let className = '3 mt-4'
        if (formElement.id == 'comment') {
            className = '12 mt-4'
        }
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col={className}
                changed={(event) => inputChangedHandlerSearch(event, formElement.id)} />
        );
    });
    formS = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row small-acc-srch">
            {formS}
            <Select
                name="form-field-name"
                value={unit}
                placeholder="واحد ناظر"
                options={unitList}
                onChange={changeUnit}
                col="3 mt-4"
            />
            <Select
                name="form-field-name"
                value={city}
                placeholder="شهر"
                options={cityList}
                onChange={changeCity}
                col="3 mt-2"
            />
        </div>
        <div className="row pl-3 mt-3" dir="ltr" >
            <Button btnType="Search" clicked={search}>جستجو</Button>
        </div>
    </div>
    return (
        <div>
            {loading ? <Spinner /> : ''}
            {!newUnitPickupAddressPage ?
                <div>
                    <Search class="orders-search" form={formS} />
                    {permission.includes != null && permission.includes('UNIT_WRITE') ?
                        <div className="row justify-content-center mt-3 ml-3">
                            <div className="UserGeneralBtn mb-2">
                                <div onClick={(event) => addNewUnitPickupAddressType(event)} className="Add">
                                    <Add className="UserIcon" />
                                </div>
                            </div>
                        </div>
                        : ''
                    }

                    {rerender ?
                        // <Spinner />
                        <Table pageSize={pageSize} data={unitPickupAddresses} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={200} loading={loading} />
                        :
                        <Table pageSize={pageSize} data={unitPickupAddresses} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={200} loading={loading} />
                    }
                    < Modal
                        content={modalContent}
                        ref={ref}
                        closePermission={true}
                        closeModal={(event) => afterCloseModal(event)}
                    />
                </div >
                :
                <UnitPickupAddressForm toggleNewUnitPickupAddressForm={toggleNewUnitPickupAddressForm} view={view} edit={edit} units={units} cities={cities} unitPickupAddress={unitPickupAddress} />
            }
        </div >
    )
}

export default UnitPickupAddresses